module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_hairmakeup-9b3f4b7dcd214eb22b12f4884eec7573.svg";